import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import secureLocalStorage from "react-secure-storage";
import { GET_GOOD_READ_ENDPOINT } from "../../config/ApisCollection";
import axios from "axios";
import { useParams } from "react-router-dom";

const GoodReadFullArticle = () => {
  const { id } = useParams();

  const [goodread_data, set_goodread_data] = useState(null);

  const accessToken = secureLocalStorage.getItem("accessToken");

  const dateformat = (row_date) => {
    const dateString = row_date;
    const date = new Date(dateString);

    // Format options
    const options = { day: "2-digit", month: "short", year: "numeric" };

    // Convert to desired format
    const formattedDate = date.toLocaleDateString("en-GB", options);

    return formattedDate; // Output: "22 Oct 2024"
  };

  const getGoodReadData = async () => {
    try {
      // Prepare request headers and body
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      };

      // Make the POST request
      const response = await axios.post(
        `${GET_GOOD_READ_ENDPOINT}/${id}`, // URL
        {}, // Body (ensure you include actual data if required)
        config // Config object (headers, etc.)
      );

      // Handle the response data
      set_goodread_data(response.data);
    } catch (error) {
      // Handle errors
    }
  };

  useEffect(() => {
    getGoodReadData();
    // console.log(type);
    window.scrollTo(0, 0);
  }, []);
  // console.log(goodread_data);
  return (
    <>
      <MainBg>
        {goodread_data !== null ? (
          <div className="container mx-auto md:px-10 px-2">
            <style>
              {" "}
              {` p{ margin-bottom:10px !important; } ul li{ list-style-type: disc; margin-bottom: 15px !important;  } ul{padding-left:30px !important;}`}{" "}
            </style>
            <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-20 py-20 mb-20 ">
              <div className="col-span-2 lg:px-10 px-1 sm:border-r-2 border-none">
                <div className="text-center">
                  <div className="text-center  mb-10 ">
                    <img
                      src={goodread_data?.date?.article?.webblogimage}
                      className="drop-shadow-lg m-auto rounded"
                      height={443}
                      width={1060}
                    />
                  </div>
                  <br />
                  <h1 className="text-lg font-bold pb-7 text-capitalize">
                    {goodread_data?.date?.article?.title}
                  </h1>
                  <div className="lg:w-1/3 md:w-1/3 sm:w-1/3 w-full border-b border-[#FE7701] m-auto mb-10 flex gap-2 justify-center">
                    <p className="text-[#FE7701] text-capitalize">
                      {goodread_data?.date?.article?.category}
                    </p>
                    <p className="text-[gray]">•</p>
                    <p className="text-[gray] text-capitalize">
                      {dateformat(goodread_data?.date?.article?.updatedAt)}
                    </p>
                  </div>
                </div>
                <div className="lg:px-20 px-0">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: goodread_data?.date?.article?.description,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </MainBg>
    </>
  );
};
export default React.memo(GoodReadFullArticle);
